var map = {
	"./default_icon_gray.png": 1077,
	"./face_1_gray.png": 1414,
	"./face_2_bis_gray.png": 6153,
	"./face_2_gray.png": 3932,
	"./face_3_gray.png": 8066,
	"./face_4_gray.png": 1931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5951;